import {ComponentFactoryResolver, Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {PanelsService} from '@ispm/layout/services/panels.service';
import {PanelLoaderPayload} from '@ispm/layout/classes/panel-loader-payload.abstract';
import {NodeCreatorComponent} from '@ispm-client/modules/bpmn-modeler/node-creator.component/node-creator.component';
import {TreatmentPlanSelectorComponent} from '@ispm-client/modules/bpmn-modeler/treatment-plan-selector.component/treatment-plan-selector.component';
import {ClinicalTrialSelectorComponent} from "@ispm-client/modules/bpmn-modeler/clinical-trial-selector.component/clinical-trial-selector.component";
import {DynamicModalLoaderService} from "@ispm/layout/services/dynamic-modal-loader.service";
import {Subscription} from "rxjs";
import {NodePanelConfigurationService} from "@ispm-client/modules/bpmn-modeler/service/node-panel-configuration.service";

@Injectable()
export class ModelerPanelService {

  static readonly ModelerPanelName = 'modelerPanel';
  private componentsMap = [{ key: 'nodeCreator', value: NodeCreatorComponent},
                          { key: 'treatmentSelector', value: TreatmentPlanSelectorComponent},
                          { key: 'clinicalTrialSelector', value: ClinicalTrialSelectorComponent}];
  protected modalSubscriber$: Subscription;

  constructor(private componentFactoryResolver: ComponentFactoryResolver,
              private panelService: PanelsService,
              protected modalLoader: DynamicModalLoaderService,
              private nodePanelConfigurationService: NodePanelConfigurationService) {}

  public openNodeBuilder(config, data, readOnlyMode, approveCallback: (...args) => void): Observable<any> {
    return this.openNodeBuilderWithComponent('nodeCreator', config, data, undefined, readOnlyMode, approveCallback);
  }

  public openTreatmentPlanSelector(config, data, revisedEntitiesRevisionsData, readOnlyMode, approveCallback: (...args) => void): Observable<any> {
    return this.openNodeBuilderWithComponent('treatmentSelector', config, data, revisedEntitiesRevisionsData, readOnlyMode, approveCallback);
  }

  public openNodeBuilderWithComponent(componentKey: string, config, data, revisedEntitiesRevisionsData, readOnlyMode, approveCallback: (...args) => void): Observable<any> {
    const foundArray = this.componentsMap.filter(item => item.key === componentKey).map(item => item.value);
    if(foundArray.length >0) {
      this.nodePanelConfigurationService.panelState = true;
      return this.openPanel(foundArray[0], config, data, revisedEntitiesRevisionsData, readOnlyMode, approveCallback);
    }
  }

  public closePanel(): Observable<any> {
    this.panelService.hideLayout(ModelerPanelService.ModelerPanelName);
    this.nodePanelConfigurationService.panelState = false;
    return Observable.empty();
  }

  private openPanel(component: any, config, data, revisedEntitiesRevisionsData, readOnlyMode,approveCallback: (...args) => void): Observable<any> {
    const definition = PanelLoaderPayload.builder()
      .setTitle(config.label)
      .setPayload({data, config, revisedEntitiesRevisionsData, readOnlyMode})
      .setApproveCallback(approveCallback);
    return this.panelService.showLayout(component, definition, ModelerPanelService.ModelerPanelName);
  }
}
